import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import NotFound from '../../NotFound/NotFound'
import IssueReasonList from './ManageIssueReason/IssueReasonList'
import IssueTypeList from './ManageIssueType/IssueTypeList'

const ManageIssueAndRejection = () => {
  const [activeToggle, setActiveToggle] = useState('issue-type')
  const { pageAccess } = useSelector((state) => state.user)

  const handleTabClick = (e, tabName) => {
    e.preventDefault()
    setActiveToggle(tabName)
  }

  return checkPageAccess(
    pageAccess,
    allPages?.manageIssueandRejection,
    allCrudNames?.read
  ) ? (
    <>
      {checkPageAccess(
        pageAccess,
        allPages?.manageIssueandRejection,
        allCrudNames?.read
      ) && (
        <div className='card overflow-hidden'>
          <div className='card-body p-0'>
            <div className='nav-tabs-horizontal nav nav-tabs'>
              <Link
                onClick={(e) => handleTabClick(e, 'issue-type')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'issue-type' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Issue Type
                  <hr />
                </span>
              </Link>
              <Link
                onClick={(e) => handleTabClick(e, 'issue-reason')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'issue-reason' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Issue Reason
                  <hr />
                </span>
              </Link>{' '}
            </div>
            <div className='tab-content p-3'>
              <div
                id='issue-type'
                className={`tab-pane fade ${
                  activeToggle === 'issue-type' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'issue-type' && <IssueTypeList />}
              </div>

              <div
                id='issue-reason'
                className={`tab-pane fade ${
                  activeToggle === 'issue-reason' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'issue-reason' && <IssueReasonList />}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  ) : (
    <NotFound />
  )
}

export default ManageIssueAndRejection
